/**
 * Este arquivo contém correções para problemas conhecidos do Bootstrap
 */

/**
 * Limpa elementos backdrop órfãos e modais que possam estar causando problemas
 * Esta função deve ser chamada quando ocorrem erros relacionados a modais
 * 
 * A limpeza é feita com cuidado para não interferir com elementos ativos.
 */
export const cleanupBootstrapModalElements = () => {
  try {
    // Verificar se existem modais abertos antes de limpar
    const openModals = document.querySelectorAll('.modal.show');
    
    // Se existirem modais abertos, não faça a limpeza para não afetar a funcionalidade
    if (openModals.length > 0) {
      return;
    }
    
    // Verificar se há dropdowns abertos (ativos)
    const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
    
    // Se existirem dropdowns abertos, não faça a limpeza
    if (openDropdowns.length > 0) {
      return;
    }
    
    // Remover backdrops órfãos que possam ter ficado na página
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => {
      backdrop.classList.remove('show');
      setTimeout(() => {
        if (backdrop && backdrop.parentNode) {
          backdrop.remove();
        }
      }, 150);
    });
    
    // Remover classes modal-open do body somente se não houver modais visíveis
    if (!document.querySelector('.modal.show')) {
      document.body.classList.remove('modal-open');
      
      // Remover estilos inline adicionados pelo Bootstrap
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
      if (document.body.style.paddingRight) {
        document.body.style.paddingRight = '';
      }
    }
  } catch (error) {
    console.warn('Erro não crítico ao limpar elementos modais:', error);
  }
};

/**
 * Versão simplificada da função fixBootstrapModalBackdropIssue
 * Faz apenas o essencial para evitar problemas com o backdrop dos modais
 */
export const fixBootstrapModalBackdropIssue = () => {
  // Aplicar patch para corrigir o erro "Cannot read properties of null (reading 'hide')"
  patchBootstrapModal();
  
  // Limpa elementos problemáticos
  cleanupBootstrapModalElements();
  
  // Verifica se o Bootstrap está disponível
  if (typeof window !== 'undefined' && window.bootstrap && window.bootstrap.Modal) {
    try {
      // Verifica se há modais abertos
      const openModals = document.querySelectorAll('.modal.show');
      if (openModals.length === 0) {
        // Remove qualquer backdrop órfão
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => {
          backdrop.classList.remove('show');
          setTimeout(() => {
            if (backdrop && backdrop.parentNode) {
              backdrop.remove();
            }
          }, 150);
        });
      }
    } catch (error) {
      console.warn('Erro ao aplicar correção de backdrop:', error);
    }
  }
};

/**
 * Função específica para corrigir o erro "Cannot read properties of null (reading 'hide')"
 * Este erro ocorre quando o bootstrap tenta chamar .hide() em um elemento que não existe mais
 */
function patchBootstrapModal() {
  if (typeof window === 'undefined' || !window.bootstrap || !window.bootstrap.Modal) {
    return;
  }

  // Verificar se já aplicamos o patch
  if (window.bootstrap.Modal._patched) {
    return;
  }
  
  // Salvar a função original
  const originalHide = window.bootstrap.Modal.prototype.hide;
  
  // Substituir com uma versão segura que verifica se o elemento existe
  window.bootstrap.Modal.prototype.hide = function(...args) {
    try {
      // Verificar se o elemento modal ainda existe no DOM
      if (this._element && document.body.contains(this._element)) {
        return originalHide.apply(this, args);
      } else {
        console.warn('Tentativa de chamar hide() em um elemento modal que não existe mais');
        // Limpeza adicional
        cleanupBootstrapModalElements();
      }
    } catch (error) {
      console.warn('Erro tratado no método hide() do modal:', error);
      // Tentar limpar
      cleanupBootstrapModalElements();
    }
  };
  
  // Marcar como corrigido
  window.bootstrap.Modal._patched = true;
  
  // Adicionar um listener global para erros relacionados ao Bootstrap
  window.addEventListener('error', function(event) {
    if (event.error && event.error.message && 
        (event.error.message.includes('Cannot read properties of null') || 
         event.error.message.includes('hide'))) {
      console.warn('Capturado erro global do Bootstrap:', event.error.message);
      cleanupBootstrapModalElements();
      event.preventDefault(); // Evita que o erro seja propagado
    }
  });
}
